import axios from "axios";
import jwtDecode from "jwt-decode";
import { refreshToken } from "services/authServices";
import { baseURLApi } from "./index"

const requestJWT = axios.create({
  baseURL: baseURLApi,
});

// https://api-my-store.herokuapp.com/v1
// http://localhost:5000/v1

requestJWT.interceptors.request.use(
  async (config) => {
    let date = new Date();
    const account = JSON.parse(localStorage.getItem('userInfo')) ?? ''

    const tokenDecode = jwtDecode(account.info.token);
    if (tokenDecode.exp < date.getTime() / 1000) {
      const formData = {
        refresh: account.info.refresh
      }
      const result = await refreshToken(formData);
      if (result.status === true) {
        account.info.token = result.data;
        localStorage.setItem("userInfo", JSON.stringify(account));
        config.headers["token"] = result.data;
      }
    } else {
      config.headers["token"] = account.info.token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default requestJWT;
